import React, { Component } from 'react'
import { connect } from 'react-redux'
import { NavLink } from 'react-router-dom'

import { selectTodos, selectCoappTodos } from '../../reducers/refiTransactions'
import RefiTransactionsTodoCard from './refiTransactionsTodoCard'
import { fetchRefiTransactionTodos } from './refiTransactionsActions'
import { Todo } from '../tasks/types'

export type Callback<T = void> = (...args: any) => T

export interface Props {
  fetchRefiTransactionTodos: Callback
  id: string
  user: string
  refiCoappTodos: Todo[]
  refiTodos: Todo[]
}

export class RefiTransactionsTodos extends Component<Props> {
  static displayName = 'RefiTransactionsTodos'

  componentDidMount() {
    const { fetchRefiTransactionTodos, id } = this.props
    fetchRefiTransactionTodos(id)
  }

  internalUrl = (todo: Todo) => {
    switch (todo.type) {
      case 'APP_FOR_TITLE':
      case 'CARFAX_FRAUD_REVIEW':
      case 'CONTACT_LIENHOLDER':
      case 'DRIVER_LICENSE':
      case 'FINAL_LOAN':
      case 'HANDLE_INSUFFICIENT_FUNDS':
      case 'HANDLE_TITLE':
      case 'IMAGE':
      case 'INSURANCE_POLICY':
      case 'LOSS_PAYEE':
      case 'PROOF_OF_EMPLOYMENT':
      case 'PROOF_OF_INSURANCE':
      case 'PROOF_OF_RESIDENCE':
      case 'CURRENT_MORTGAGE_STATEMENT':
      case 'RECEIVE_APP_FOR_TITLE':
      case 'RECEIVE_LPOA':
      case 'RECEIVE_SPOA':
      case 'REGISTRATION':
      case 'REVIEW_FOR_FRAUD':
      case 'REVIEW_PLAID_DATA_MISMATCH':
      case 'REVIEW_USER_DATA_MISMATCH':
      case 'SEND_BUYER_PACKET':
      case 'SEND_FUNDS_TO_LIENHOLDER':
      case 'SEND_SPOA_TO_SELLER':
      case 'SIGN_LOAN_AGREEMENT':
      case 'SSN_CARD':
      case 'SUBMIT_PROOF_OF_INCOME':
      case 'TEXT':
      case 'TITLE':
      case 'UPDATE_LIENHOLDER':
      case 'UPDATE_LIENHOLDER_INFO':
      case 'VERIFY_FUNDS':
      case 'VERIFY_MILEAGE':
        return `/tasks/${todo.task.id}/edit`
      default:
        return null
    }
  }

  externalUrl = (todo: Todo) => {
    switch (todo.type) {
      case 'REVIEW_OFAC':
      case 'REVIEW_STATEMENT':
        return `${process.env.REACT_APP_ADMIN_WEB_URL}refinance/detail/${this.props.id}`
      default:
        return null
    }
  }

  render() {
    const { refiTodos, refiCoappTodos } = this.props

    return (
      <div className="refi-transactions-todos">
        <div className="refi-transactions-todos__header">APPLICANT TO-DOS</div>
        <div className="refi-transactions-todos__applicant-todos">
          {refiTodos.length < 1 ? (
            <div>No Todos Available</div>
          ) : (
            <div>
              {refiTodos.map((todo, i) => {
                return (
                  <RefiTransactionsTodoCard
                    key={i}
                    todo={todo}
                    externalLink={this.externalUrl(todo)}
                    internalLink={this.internalUrl(todo)}
                  />
                )
              })}
            </div>
          )}
          <NavLink to={`/refinance/${this.props.id}/custom-todo`}>
            Add Custom Todo
          </NavLink>
        </div>
        <div className="refi-transactions-todos__header">
          CO-APPLICANT TO-DOS
        </div>
        <div className="refi-transactions-todos__coapplicant-todos">
          {refiCoappTodos.length < 1 ? (
            <div>No Todos Available</div>
          ) : (
            <div>
              {refiCoappTodos.map((todo, i) => {
                return (
                  <RefiTransactionsTodoCard
                    key={i}
                    todo={todo}
                    externalLink={this.externalUrl(todo)}
                    internalLink={this.internalUrl(todo)}
                  />
                )
              })}
            </div>
          )}
        </div>
      </div>
    )
  }
}

export const mapStateToProps = (state) => {
  return {
    refiTodos: selectTodos(state.refiTransactions.todos),
    refiCoappTodos: selectCoappTodos(state.refiTransactions.todos),
  }
}

export default connect(mapStateToProps, {
  fetchRefiTransactionTodos,
})(RefiTransactionsTodos)
